/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/PolicyCard" />
import * as React from "react";
import { Components } from "VSS/Platform/Layout";
import { IBasicIdentityRef } from "VSSUI/Persona";
import { getIdentity, getPropertyValue } from "../Utils/ActivityFeedUtils";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";
import { ActivityShimmer } from "./ActivityShimmer";
import { RequiredReviewerPolicyCard } from "./RequiredReviewerPolicyCard";

export const PolicyCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    const policyType = getPropertyValue(props.thread, "CodeReviewPolicyType");
    if (policyType && policyType === "fd2167ab-b0be-447a-8ec8-39368250530e") {
        const { isShim } = props;
        const numFiles = parseInt(getPropertyValue(props.thread, "CodeReviewRequiredReviewerNumFilesThatTriggered", "0"));

        const exampleFilePath = getPropertyValue(props.thread, "CodeReviewRequiredReviewerExamplePathThatTriggered");

        const exampleIdentitiesIds: string[] = JSON.parse(getPropertyValue(props.thread, "CodeReviewRequiredReviewerExampleReviewerIdentities"));

        const exampleIdentities: IBasicIdentityRef[] = [];
        for (let i = 0; i < exampleIdentitiesIds.length; i++) {
            const identity = getIdentity(props.thread, exampleIdentitiesIds[i]);
            identity && exampleIdentities.push(identity);
        }

        let numReviewers = parseInt(getPropertyValue(props.thread, "CodeReviewRequiredReviewerNumReviewers", "0"));
        numReviewers += exampleIdentities ? exampleIdentities.length : 0;

        const isRequired = getPropertyValue(props.thread, "CodeReviewRequiredReviewerIsRequired", "True") !== "False";

        const message = getPropertyValue(props.thread, "CodeReviewRequiredReviewerUserConfiguredMessage", "");

        return isShim ? (
            <ActivityCardSubtle createDate={props.thread.publishedDate}>
                <ActivityShimmer />
            </ActivityCardSubtle>
        ) : (
            <RequiredReviewerPolicyCard
                areReviewersRequired={isRequired}
                filePath={exampleFilePath}
                identities={exampleIdentities}
                message={message}
                numFiles={numFiles}
                numReviewers={numReviewers}
                publishDate={props.thread.publishedDate}
            />
        );
    }

    return null;
};

Components.add("ms.vss-code-web.policy-activity-card", PolicyCard);
